import SVG from './SVG.styled';
import { IPropsSVGType } from 'src/types/svg.types';

export default function Attention({color="main-color", hover="main-color"}: IPropsSVGType) {
  return (
    <SVG
      $hover={hover}
      $color={color}
      $isHover={true}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M13.5 3.98077C8.24267 3.98077 3.98077 8.24267 3.98077 13.5C3.98077 18.7573 8.24267 23.0192 13.5 23.0192C18.7573 23.0192 23.0192 18.7573 23.0192 13.5C23.0192 8.24267 18.7573 3.98077 13.5 3.98077ZM2.25 13.5C2.25 7.28679 7.28679 2.25 13.5 2.25C19.7131 2.25 24.75 7.28679 24.75 13.5C24.75 19.7131 19.7131 24.75 13.5 24.75C7.28679 24.75 2.25 19.7131 2.25 13.5Z" />
        <path d="M13.5001 8.59766C13.978 8.59766 14.3655 8.9851 14.3655 9.46304V14.0784C14.3655 14.5564 13.978 14.9439 13.5001 14.9439C13.0222 14.9439 12.6348 14.5564 12.6348 14.0784V9.46304C12.6348 8.9851 13.0222 8.59766 13.5001 8.59766Z" />
        <path d="M14.6538 17.5366C14.6538 18.1739 14.1372 18.6905 13.5 18.6905C12.8628 18.6905 12.3462 18.1739 12.3462 17.5366C12.3462 16.8994 12.8628 16.3828 13.5 16.3828C14.1372 16.3828 14.6538 16.8994 14.6538 17.5366Z" />
    </SVG>
  );
}
